/**
 * Whether something on the page has frozen JavaScript's built-in prototypes,
 * as hardened headless browsers do. Libraries then break on ordinary code:
 * dayjs can't define its own `valueOf` (Sentry #3111), HubSpot can't delete a
 * function's `toString` (#3110). No browser freezes them by itself and
 * nothing we ship does, so errors from such a page aren't actionable.
 */
export const hasFrozenBuiltIns = (
	prototypes: readonly object[] = [Object.prototype, Function.prototype]
) => prototypes.some((prototype) => Object.isFrozen(prototype));
